module.exports = __webpack_public_path__ + "img/res_icon.986a1435.svg";